import React, {useState, useEffect} from 'react'
import Standings from './Standings'
import Header from './Header'

import '../App.css'
import { useTournamentDetails } from '../hooks/useTournamentDetails'

const StandingsOnly = (props) => {   
  const tournamentId = props.match.params.tournamentId
  const hash = props.location.hash
  const tournamentDetails = useTournamentDetails(tournamentId)

  return (
    <>
    <div>
      <Header hideLinks={true}/>
    </div>
    <div className="wrapper">  
    {
      (tournamentDetails && tournamentDetails.show_standings === '0')
        ? <div className='no-standings-standings-only'><h3>The Tournament is currently OFFLINE pending Final Results.</h3><br/><img src='/bass.png'></img></div>
        : <Standings details={tournamentDetails} tournamentId={tournamentId} hash={hash} hideProfileLink={true}/>
    }
    </div>
    </>
  )
}

export default StandingsOnly